import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Certificates.css';
import Pagination from '../../components/Pagination';
import { apiFetch, apiFetchBlob } from '../../utils/api';

import Statistics from '../../images/Statistics.jpg';
import Sqlimage from '../../images/Sqlimage.jpg';
import salesforce from '../../images/salesforce.png';
import productengineeringandservices from '../../images/productengineeringandservices.png';
import H1BSTAFF from '../../images/H1BSTAFF.png';
import erp from '../../images/erp.png';
import entierpriseandarchitecture from '../../images/entierpriseandarchitecture.png';
import datascienceandai from '../../images/datascienceandai.png';
import machinelearning from '../../images/machinelearning.jpg';
import azure from '../../images/azure.jpg';
import aws from '../../images/aws.jpg';
import airflow from '../../images/airflow.jpg';
import dbt from '../../images/dbt.jpg';
import deeplearning from '../../images/deeplearning.jpg';
import kafka from '../../images/kafka.jpg';
import gcp from '../../images/gcp.jpg';
import tableau from '../../images/tableau.jpg';
import pyspark from '../../images/pyspark.jpg';
import r from '../../images/r.jpg';
import matplotlib from '../../images/matplotlib.jpg';
import pandas from '../../images/pandas.jpg';
import hadoop from '../../images/hadoop.jpg';
import numpy from '../../images/numpy.jpg';
import oci from '../../images/oci.jpg';
import automation from '../../images/automation.jpg';
import springboot from '../../images/springboot.jpg';
import react from '../../images/react.jpg';
import mulesoft from '../../images/mulesoft.jpg';
import kubernetes from '../../images/kubernetes.png';
import java from '../../images/java.jpg';
import javascript from '../../images/javascript.jpg';
import django from '../../images/django.jpg';
import angular from '../../images/angular.jpg';
import course1 from '../../images/course1.jpg';
const courseImageMap = {
  "Statistics": Statistics,
  "SQL": Sqlimage,
  "Salesforce": salesforce,
  "Product Engineering": productengineeringandservices,
  "H1B STAFF": H1BSTAFF,
  "ERP": erp,
  "Enterprise Architecture": entierpriseandarchitecture,
  "Data Science & AI": datascienceandai,
  "Machine Learning": machinelearning,
  "Azure": azure,
  "AWS": aws,
  "Airflow": airflow,
  "DBT": dbt,
  "Deep Learning": deeplearning,
  "Kafka": kafka,
  "GCP": gcp,
  "Tableau": tableau,
  "PySpark": pyspark,
  "R": r,
  "Matplotlib": matplotlib,
  "Pandas": pandas,
  "Hadoop": hadoop,
  "NumPy": numpy,
  "OCI": oci,
  "Automation": automation,
  "Spring Boot": springboot,
  "React": react,
  "MuleSoft": mulesoft,
  "Kubernetes": kubernetes,
  "Java": java,
  "JavaScript": javascript,
  "Django": django,
  "Angular": angular,
  "Python": course1,
  "Gen AI": datascienceandai
};

// Helper functions for formatting data
const formatCertificates = (certificatesData) => {
  return certificatesData.map((cert) => ({
    certificate_id: cert.certificate_id,
    title: cert.course_name,
    status: 'Completed',
    date: cert.issued_at.split('T')[0],
    description: cert.description || 'Certificate for course completion',
    image: courseImageMap[cert.course_name.replace(` ${cert.course_level || 'Beginner'}`, '').trim()] || course1,
    blob_name: cert.blob_name,
    filename: cert.filename,
  }));
};

const formatExternalCertificates = (data) => {
  return data.map((cert) => ({
    id: cert.id,
    title: cert.course_name,
    provider: cert.provider,
    status: cert.status,
    approval_status: cert.approval_status,
    date: cert.uploaded_at.split('T')[0],
    proof_url: cert.proof_url,
    file_type: cert.file_type,
    image: courseImageMap[cert.provider] || course1,
    learning_path_assignment_id: cert.learning_path_assignment_id,
  }));
};

const formatCourses = (coursesData) => {
  return coursesData.map((course) => ({
    courseId: course.course_id,
    name: course.course_title || `Course ${coursesData.indexOf(course) + 1}`,
    department: course.department_name || 'Unknown',
    image: courseImageMap[course.course_title.replace(` ${course.course_level}`, '').trim()] || course1,
    level: course.course_level || 'Beginner',
    requiredFor: course.course_category || 'General',
    video_count: course.video_count || 0,
    total_duration: course.total_duration || 'N/A',
  }));
};

const getUniqueCourses = (formattedCourses) => {
  return formattedCourses.filter(
    (course, index, self) => index === self.findIndex((c) => c.name === course.name)
  );
};

// Helper function to show notification
const showNotification = (message, isError = false) => {
  const snackbar = document.createElement('div');
  snackbar.textContent = message;
  snackbar.style.cssText = `position: fixed; top: 20px; left: 50%; transform: translateX(-50%); background-color: ${isError ? '#f44336' : '#4CAF50'}; color: white; padding: 12px 24px; border-radius: 4px; z-index: 1000;`;
  document.body.appendChild(snackbar);
  setTimeout(() => snackbar.remove(), 3000);
};

const Certificates = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [certificates, setCertificates] = useState([]);
  const [externalCertificates, setExternalCertificates] = useState([]);
  const [availableCertificates, setAvailableCertificates] = useState([]);
  const [loadingCertificates, setLoadingCertificates] = useState(true);
  const [loadingExternal, setLoadingExternal] = useState(true);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [errorCertificates, setErrorCertificates] = useState(null);
  const [errorExternal, setErrorExternal] = useState(null);
  const [errorCourses, setErrorCourses] = useState(null);
  const [categories, setCategories] = useState(['All Categories']);
  const [selectedCategory, setSelectedCategory] = useState('All Categories');
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState('');
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [learningPathAssignments, setLearningPathAssignments] = useState([]);
  const [externalCourses, setExternalCourses] = useState([]);
  const [allExternalCourses, setAllExternalCourses] = useState([]);
  const [userEmail, setUserEmail] = useState('');
  const [userId, setUserId] = useState(null);
  const [formData, setFormData] = useState({
    learning_path_assignment_id: '',
    external_course_id: '',
    certificate_date: '',
    notes: '',
    file: null,
  });
  const [formError, setFormError] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [certificateThumbnails, setCertificateThumbnails] = useState({});
  const [externalThumbnails, setExternalThumbnails] = useState({});
  const [selectedLearningPath, setSelectedLearningPath] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfoAndCertificates = async () => {
      try {
        setLoadingCertificates(true);
        const email = localStorage.getItem('userEmail');
        if (!email) {
          setErrorCertificates('User email not found');
          setLoadingCertificates(false);
          return;
        }
        setUserEmail(email);

        const userInfo = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${email}`);
        const userId = userInfo.user_id;
        setUserId(userId);

        const certificatesData = await apiFetch(`${window._env_.API_BASE_URL}/certificates/user/${userId}`);
        setCertificates(formatCertificates(certificatesData));
      } catch (err) {
        if (err.message.includes('404')) {
          setCertificates([]);
        } else {
          setErrorCertificates(err.message);
        }
      } finally {
        setLoadingCertificates(false);
      }
    };

    fetchUserInfoAndCertificates();
  }, []);

  useEffect(() => {
    const fetchExternalCertificates = async () => {
      if (!userEmail) return;
      try {
        setLoadingExternal(true);
        const data = await apiFetch(`${window._env_.API_BASE_URL}/external-certificates/user/${userEmail}`);
        setExternalCertificates(formatExternalCertificates(data));
      } catch (err) {
        if (err.message.includes('404')) {
          setExternalCertificates([]);
        } else {
          setErrorExternal(err.message);
        }
      } finally {
        setLoadingExternal(false);
      }
    };

    fetchExternalCertificates();
  }, [userEmail]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      if (!userEmail) return;
      try {
        const [assignments, courses] = await Promise.all([
          apiFetch(`${window._env_.API_BASE_URL}/external-certificates/learning-path-assignments/user/${userEmail}`),
          apiFetch(`${window._env_.API_BASE_URL}/external-certificates/external-courses`)
        ]);

        setLearningPathAssignments(assignments);
        setAllExternalCourses(courses);
      } catch (err) {
        console.error('Error fetching dropdowns:', err);
      }
    };

    fetchDropdowns();
  }, [userEmail]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoadingCourses(true);
        const coursesData = await apiFetch(`${window._env_.API_BASE_URL}/courses/summary`);
        const formattedCourses = formatCourses(coursesData);
        const uniqueCourses = getUniqueCourses(formattedCourses);
        setAvailableCertificates(uniqueCourses);
      } catch (err) {
        if (err.message.includes('404')) {
          setAvailableCertificates([]);
        } else {
          setErrorCourses(err.message);
        }
      } finally {
        setLoadingCourses(false);
      }
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const uniqueCategories = [
      'All Categories',
      ...new Set(availableCertificates.map(course => course.requiredFor).filter(category => category && category !== 'null'))
    ];
    setCategories(uniqueCategories);
  }, [availableCertificates]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.cert-options-icon') && !event.target.closest('.cert-dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Fetch thumbnails for My Certificates
  useEffect(() => {
    const fetchCertificateThumbnails = async () => {
      if (certificates.length === 0) return;

      const thumbnails = {};
      for (const cert of certificates) {
        try {
          const endpoint = `${window._env_.API_BASE_URL}/certificates/view/${cert.certificate_id}.pdf`;
          const blob = await apiFetchBlob(endpoint);
          const url = window.URL.createObjectURL(blob);
          thumbnails[cert.certificate_id] = url + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH';
        } catch (err) {
          console.error(`Error fetching thumbnail for certificate ${cert.certificate_id}:`, err);
          thumbnails[cert.certificate_id] = null;
        }
      }
      setCertificateThumbnails(thumbnails);
    };

    fetchCertificateThumbnails();

    // Cleanup blob URLs on unmount
    return () => {
      Object.values(certificateThumbnails).forEach(url => {
        if (url && url.startsWith('blob:')) {
          window.URL.revokeObjectURL(url);
        }
      });
    };
  }, [certificates]);

  // Fetch thumbnails for External Certificates
  useEffect(() => {
    const fetchExternalThumbnails = async () => {
      if (externalCertificates.length === 0) return;

      const thumbnails = {};
      for (const cert of externalCertificates) {
        try {
          const endpoint = `${window._env_.API_BASE_URL}/external-certificates/view/${cert.id}`;
          const blob = await apiFetchBlob(endpoint);
          const url = window.URL.createObjectURL(blob);
          thumbnails[cert.id] = cert.file_type === 'application/pdf'
            ? url + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH'
            : url;
        } catch (err) {
          console.error(`Error fetching thumbnail for external certificate ${cert.id}:`, err);
          thumbnails[cert.id] = null;
        }
      }
      setExternalThumbnails(thumbnails);
    };

    fetchExternalThumbnails();

    // Cleanup blob URLs on unmount
    return () => {
      Object.values(externalThumbnails).forEach(url => {
        if (url && url.startsWith('blob:')) {
          window.URL.revokeObjectURL(url);
        }
      });
    };
  }, [externalCertificates]);

  const handleLearningPathChange = (value) => {
    setSelectedLearningPath(value);
    setFormData((prev) => ({ ...prev, external_course_id: '' }));
    const selectedAssignment = learningPathAssignments.find(a => a.id === parseInt(value));
    if (selectedAssignment) {
      const filteredCourses = allExternalCourses.filter(c => c.learning_path_ids.includes(selectedAssignment.learning_path_id));
      setExternalCourses(filteredCourses);
    } else {
      setExternalCourses([]);
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === 'learning_path_assignment_id') {
      handleLearningPathChange(value);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        setFormError('File must be PNG, JPG, or PDF only');
        setFormData((prev) => ({ ...prev, file: null }));
        return;
      }
      if (file.size > 3 * 1024 * 1024) {
        setFormError('File size must not exceed 3MB');
        setFormData((prev) => ({ ...prev, file: null }));
        return;
      }
      setFormError('');
      setFormData((prev) => ({ ...prev, file }));
    }
  };

  const validateUploadForm = () => {
    if (!formData.external_course_id || !formData.certificate_date || !formData.file) {
      setFormError('External course, certificate date, and file are required');
      return false;
    }
    return true;
  };

  const prepareUploadFormData = () => {
    const formDataToSend = new FormData();
    formDataToSend.append('user_email', userEmail);
    formDataToSend.append('external_course_id', formData.external_course_id);
    formDataToSend.append('certificate_date', formData.certificate_date);
    if (formData.learning_path_assignment_id) {
      formDataToSend.append('learning_path_assignment_id', formData.learning_path_assignment_id);
    }
    if (formData.notes) formDataToSend.append('notes', formData.notes);
    formDataToSend.append('file', formData.file);
    return formDataToSend;
  };

  const resetUploadForm = () => {
    setFormData({
      learning_path_assignment_id: '',
      external_course_id: '',
      certificate_date: '',
      notes: '',
      file: null,
    });
    setSelectedLearningPath('');
    setExternalCourses([]);
    setShowUploadModal(false);
  };

  const handleUploadSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    setIsUploading(true);

    if (!validateUploadForm()) {
      setIsUploading(false);
      return;
    }

    try {
      const formDataToSend = prepareUploadFormData();
      await apiFetch(`${window._env_.API_BASE_URL}/external-certificates/upload`, {
        method: 'POST',
        body: formDataToSend,
      });

      const externalData = await apiFetch(`${window._env_.API_BASE_URL}/external-certificates/user/${userEmail}`);
      setExternalCertificates(formatExternalCertificates(externalData));
      showNotification('Certificate uploaded successfully');
      resetUploadForm();
    } catch (err) {
      setFormError(err.message);
      showNotification(`Upload failed: ${err.message}`, true);
    } finally {
      setIsUploading(false);
    }
  };

  const handleViewCertificate = async (certificateId, isExternal = false) => {
    if (!certificateId) return;

    setShowCertificateModal(true);
    setCertificateUrl('');
    try {
      const endpoint = isExternal
        ? `${window._env_.API_BASE_URL}/external-certificates/view/${certificateId}`
        : `${window._env_.API_BASE_URL}/certificates/view/${certificateId}.pdf`;
      const blob = await apiFetchBlob(endpoint);
      const url = window.URL.createObjectURL(blob);
      setCertificateUrl(url);
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 30000);
    } catch (err) {
      console.error('Error fetching certificate:', err);
      showNotification(`Failed to view certificate: ${err.message}`, true);
      setShowCertificateModal(false);
    }
  };

  const handleDownloadCertificate = async (certificateId) => {
    try {
      const endpoint = `${window._env_.API_BASE_URL}/external-certificates/download/${certificateId}`;
      const blob = await apiFetchBlob(endpoint);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `certificate_${certificateId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setActiveDropdown(null);
    } catch (err) {
      console.error('Error downloading certificate:', err);
      showNotification(`Failed to download certificate: ${err.message}`, true);
    }
  };

  const closeCertificateModal = () => {
    setShowCertificateModal(false);
    if (certificateUrl.startsWith('blob:')) {
      window.URL.revokeObjectURL(certificateUrl); // Clean up blob URL
    }
    setCertificateUrl('');
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
    setFormError('');
    setIsUploading(false);
    setFormData({
      learning_path_assignment_id: '',
      external_course_id: '',
      certificate_date: '',
      notes: '',
      file: null,
    });
    setSelectedLearningPath('');
    setExternalCourses([]);
  };

  const handleEnroll = async (courseId, department) => {
    try {
      if (!userEmail) {
        sessionStorage.setItem('redirectAfterLogin', window.location.pathname + window.location.search);
        navigate('/Login');
        return;
      }

      if (!userId) {
        throw new Error('User ID not found');
      }

      await apiFetch(`${window._env_.API_BASE_URL}/users/${userId}/enroll`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: courseId }),
      });

      showNotification('Successfully enrolled in the course');
      setTimeout(() => {
        navigate('/course-videos', { state: { courseId, department } });
      }, 3000);
    } catch (error) {
      console.error('Enrollment error:', error);
      showNotification(`Enrollment failed: ${error.message}`, true);
    }
  };

  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  const filteredCourses = selectedCategory === 'All Categories'
    ? availableCertificates
    : availableCertificates.filter(course => course.requiredFor === selectedCategory);

  if (loadingCertificates || loadingExternal || loadingCourses) {
    return <div className="cert-certificates-page">Loading...</div>;
  }

  if (errorCertificates || errorExternal || errorCourses) {
    return (
      <div className="cert-certificates-page">
        {errorCertificates && <div className="cert-error-message">Unable to fetch certificates at this time. Please try again later.</div>}
        {errorExternal && <div className="cert-error-message">Unable to fetch external certificates at this time. Please try again later.</div>}
        {errorCourses && <div className="cert-error-message">Unable to fetch available courses at this time. Please try again later.</div>}
      </div>
    );
  }

  return (
    <div className="cert-certificates-page">
      <div className="cert-page-header">
        <h1>Your Certification Journey</h1>
        <p>Track your progress and discover new certification opportunities</p>
      </div>

      <section className="cert-my-certificates-section">
        <div className="cert-section-header">
          <h2>My Certificates</h2>
        </div>
        <div className="cert-my-certificates-grid">
          {certificates.length > 0 ? (
            certificates.map((cert) => (
              <div key={cert.certificate_id} className="cert-cert-card completed">
                <div className="cert-cert-card-header">
                  <span className="cert-status-badge">
                    <i className="fa fa-check-circle"></i> {cert.status}
                  </span>
                  <span className="cert-cert-date">{cert.date}</span>
                  <i className="fa fa-ellipsis-v cert-options-icon"></i>
                </div>
                <div className="cert-thumbnail-container">
                  {certificateThumbnails[cert.certificate_id] ? (
                    <iframe
                      src={certificateThumbnails[cert.certificate_id]}
                      title={cert.title}
                      className="cert-cert-thumbnail"
                      scrolling="no"
                    ></iframe>
                  ) : (
                    <div className="cert-thumbnail-loading">
                      <div className="cert-thumbnail-spinner"></div>
                    </div>
                  )}
                </div>
                <h3>{cert.title}</h3>
                <p>{cert.description}</p>
                <div className="cert-cert-card-footer">
                  <button
                    className="cert-view-cert-btn"
                    onClick={() => handleViewCertificate(cert.certificate_id)}
                  >
                    View Certificate
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="cert-no-data">Start building your certification portfolio. Complete a course and earn your first certificate!</p>
          )}
        </div>
      </section>

      <section className="cert-external-certificates-section">
        <div className="cert-section-header">
          <h2>My External Certificates</h2>
          <button
            className="cert-upload-cert-btn"
            onClick={() => setShowUploadModal(true)}
          >
            Upload Certificate
          </button>
        </div>
        <div className="cert-my-certificates-grid">
          {externalCertificates.length > 0 ? (
            externalCertificates.map((cert) => {
              let approvalText = '';
              let approvalClass = '';
              if (cert.approval_status === 0) {
                approvalText = 'Pending Approval';
                approvalClass = 'pending';
              } else if (cert.approval_status === 1) {
                approvalText = 'Approved';
                approvalClass = 'approved';
              } else if (cert.approval_status === 2) {
                approvalText = 'Rejected';
                approvalClass = 'rejected';
              }

              return (
                <div key={cert.id} className="cert-cert-card completed">
                  <div className="cert-cert-card-header" style={{ position: 'relative' }}>
                    <span className="cert-status-badge">
                      <i className="fa fa-check-circle"></i> {cert.status.charAt(0).toUpperCase() + cert.status.slice(1)}
                      {approvalText && <span className={`cert-approval-badge ${approvalClass}`}>{approvalText}</span>}
                    </span>
                    <span className="cert-cert-date">{cert.date}</span>
                    <i
                      className="fa fa-ellipsis-v cert-options-icon"
                      onClick={() => toggleDropdown(cert.id)}
                    ></i>
                    {activeDropdown === cert.id && (
                      <div className="cert-dropdown-menu" style={{ position: 'absolute', top: '20px', right: '0', background: 'white', border: '1px solid #ccc', padding: '10px', zIndex: 1000 }}>
                        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                          <li
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDownloadCertificate(cert.id)}
                          >
                            Download
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                  <div className="cert-thumbnail-container">
                    {externalThumbnails[cert.id] ? (
                      cert.file_type === 'application/pdf' ? (
                        <iframe
                          src={externalThumbnails[cert.id]}
                          title={cert.title}
                          className="cert-cert-thumbnail"
                          scrolling="no"
                        ></iframe>
                      ) : (
                        <img
                          src={externalThumbnails[cert.id]}
                          alt={cert.title}
                          className="cert-cert-image"
                        />
                      )
                    ) : (
                      <div className="cert-thumbnail-loading">
                        <div className="cert-thumbnail-spinner"></div>
                      </div>
                    )}
                  </div>
                  <h3>{cert.title}</h3>
                  <p>Provider: {cert.provider}</p>
                  <div className="cert-cert-card-footer">
                    <button
                      className="cert-view-cert-btn"
                      onClick={() => handleViewCertificate(cert.id, true)}
                    >
                      View Certificate
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="cert-no-data">No external certificates uploaded. Upload your first external certificate!</p>
          )}
        </div>
      </section>

      {showCertificateModal && (
        <>
          <div className="cert-certificate-modal-overlay"></div>
          <div className="cert-certificate-modal" role="dialog" aria-modal="true">
            <div className="cert-certificate-modal-header">
              <h2>Certificate</h2>
              <button
                onClick={closeCertificateModal}
                className="cert-certificate-modal-close"
                aria-label="Close certificate popup"
              >
                &times;
              </button>
            </div>
            <div className="cert-certificate-modal-content">
              {certificateUrl ? (
                <iframe
                  src={certificateUrl}
                  title="Certificate"
                  frameBorder="0"
                  className="cert-certificate-iframe"
                ></iframe>
              ) : (
                <div className="cert-loading-indicator">
                  <p>Loading certificate...</p>
                  <div className="cert-spinner" style={{
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #3498db',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    animation: 'spin 1s linear infinite',
                    margin: '20px auto'
                  }}></div>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {showUploadModal && (
        <>
          <div className="cert-certificate-modal-overlay"></div>
          <div className="cert-upload-modal" role="dialog" aria-modal="true">
            <div className="cert-certificate-modal-header">
              <h2>Upload External Certificate</h2>
              <button
                onClick={closeUploadModal}
                className="cert-certificate-modal-close"
                aria-label="Close upload modal"
              >
                &times;
              </button>
            </div>
            <div className="cert-upload-modal-content">
              <form onSubmit={handleUploadSubmit}>
                <div className="cert-form-group">
                  <label htmlFor="learning_path_assignment_id">Learning Path Assignment</label>
                  <select
                    name="learning_path_assignment_id"
                    value={formData.learning_path_assignment_id}
                    onChange={handleFormChange}
                  >
                    <option value="">Select Learning Path</option>
                    {learningPathAssignments.map((assignment) => (
                      <option key={assignment.id} value={assignment.id}>
                        {assignment.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="cert-form-group">
                  <label htmlFor="external_course_id">External Course</label>
                  <select
                    name="external_course_id"
                    value={formData.external_course_id}
                    onChange={handleFormChange}
                    required
                  >
                    <option value="">Select Course</option>
                    {externalCourses.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.name} ({course.provider})
                      </option>
                    ))}
                  </select>
                </div>
                <div className="cert-form-group">
                  <label htmlFor="certificate_date">Certificate Date</label>
                  <input
                    type="date"
                    name="certificate_date"
                    value={formData.certificate_date}
                    onChange={handleFormChange}
                    required
                  />
                </div>
                <div className="cert-form-group">
                  <label htmlFor="notes">Notes (Optional)</label>
                  <textarea
                    name="notes"
                    value={formData.notes}
                    onChange={handleFormChange}
                    placeholder="Additional notes"
                  />
                </div>
                <div className="cert-form-group">
                  <label htmlFor="file">Certificate File (PNG, JPG, or PDF, max 3MB)</label>
                  <input
                    type="file"
                    name="file"
                    onChange={handleFileChange}
                    accept=".png,.jpg,.jpeg,.pdf"
                    required
                  />
                </div>
                {formError && <p className="cert-form-error">{formError}</p>}
                <div className="cert-form-actions">
                  <button
                    type="submit"
                    className="cert-upload-btn"
                    disabled={isUploading}
                  >
                    {isUploading ? 'Uploading...' : 'Upload'}
                  </button>
                  <button
                    type="button"
                    className="cert-cancel-btn"
                    onClick={closeUploadModal}
                    disabled={isUploading}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}

      <section className="cert-available-certs-section">
        <div className="cert-section-header">
          <h2>Available Certifications</h2>
          <div className="cert-filters-container">
            <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
              {categories.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="cert-available-certs-grid">
          {filteredCourses.length > 0 ? (
            filteredCourses.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            ).map((cert) => (
              <div key={cert.courseId} className="cert-available-cert-card">
                <div className="cert-card-image-container">
                  <img src={cert.image} alt={cert.name} />
                </div>
                <div className="cert-card-content">
                  <div className="cert-tags">
                    <span className="cert-category-tag">{cert.department}</span>
                    <span className="cert-level-tag">{cert.level}</span>
                  </div>
                  <h4>{cert.name}</h4>
                  <p>🎥 Videos : {cert.video_count}</p>
                  <p>⏱ Duration : {cert.total_duration}</p>
                  <div className="cert-enroll-section">
                    <span>Required for: <strong>{cert.requiredFor}</strong></span>
                    <button
                      className="cert-enroll-btn"
                      onClick={() => handleEnroll(cert.courseId, cert.department)}
                    >
                      Enroll Now
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="cert-no-data">No certifications available at the moment. Check back later for new opportunities!</p>
          )}
        </div>
      </section>

      <Pagination
        items={filteredCourses}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default Certificates;